"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Trustpilot = _interopRequireDefault(require("./Trustpilot/components/Trustpilot5"));
var _Trustpilot5Small = _interopRequireDefault(require("./Trustpilot/components/Trustpilot5Small"));
var _Trustpilot2 = _interopRequireDefault(require("./Trustpilot/components/Trustpilot45"));
var _Trustpilot45Small = _interopRequireDefault(require("./Trustpilot/components/Trustpilot45Small"));
var _TwitterBrand = _interopRequireDefault(require("./Social/components/TwitterBrand"));
var _Linkedin = _interopRequireDefault(require("./Social/components/Linkedin"));
var _LinkedinBrand = _interopRequireDefault(require("./Social/components/LinkedinBrand"));
var _YoutubeBrand = _interopRequireDefault(require("./Social/components/YoutubeBrand"));
var _Instagram = _interopRequireDefault(require("./Social/components/Instagram"));
var _FacebookBrand = _interopRequireDefault(require("./Social/components/FacebookBrand"));
var _FacebookBrand2 = _interopRequireDefault(require("./Social/components/FacebookBrand2"));
var _Facebook = _interopRequireDefault(require("./Social/components/Facebook"));
var _Gravatar = _interopRequireDefault(require("./Social/components/Gravatar"));
var _Snapchat = _interopRequireDefault(require("./Social/components/Snapchat"));
var _Twitter = _interopRequireDefault(require("./Social/components/Twitter"));
var _Whatsapp = _interopRequireDefault(require("./Social/components/Whatsapp"));
var _Tiktok = _interopRequireDefault(require("./Social/components/Tiktok"));
var _Youtube = _interopRequireDefault(require("./Social/components/Youtube"));
var _Maaji = _interopRequireDefault(require("./Logos/components/Maaji"));
var _AirTahiti = _interopRequireDefault(require("./Logos/components/AirTahiti"));
var _TywLogo = _interopRequireDefault(require("./Logos/components/TywLogo"));
var _TywMiniLogo = _interopRequireDefault(require("./Logos/components/TywMiniLogo"));
var _TswLogo = _interopRequireDefault(require("./Logos/components/TswLogo"));
var _AbtaLogo = _interopRequireDefault(require("./Logos/components/AbtaLogo"));
var _CnLogo = _interopRequireDefault(require("./Logos/components/CnLogo"));
var _Day8LogoFill = _interopRequireDefault(require("./Logos/components/Day8LogoFill"));
var _Day8Logo = _interopRequireDefault(require("./Logos/components/Day8Logo"));
var _EurotripsLogo = _interopRequireDefault(require("./Logos/components/EurotripsLogo"));
var _OhsoLogo = _interopRequireDefault(require("./Logos/components/OhsoLogo"));
var _YnfLogo = _interopRequireDefault(require("./Logos/components/YnfLogo"));
var _QdLogo = _interopRequireDefault(require("./Logos/components/QdLogo"));
var _Ultra = _interopRequireDefault(require("./Logos/components/Ultra"));
var _YnfLogoFill = _interopRequireDefault(require("./Logos/components/YnfLogoFill"));
var _YnfMiniLogo = _interopRequireDefault(require("./Logos/components/YnfMiniLogo"));
var _YnfLogoBlackOutline = _interopRequireDefault(require("./Logos/components/YnfLogoBlackOutline"));
var _Visa = _interopRequireDefault(require("./Logos/components/Visa"));
var _Mastercard = _interopRequireDefault(require("./Logos/components/Mastercard"));
var _Amex = _interopRequireDefault(require("./Logos/components/Amex"));
var _AegeanLogo = _interopRequireDefault(require("./Logos/components/AegeanLogo"));
var _VacayLogo = _interopRequireDefault(require("./Logos/components/VacayLogo"));
var _TswLogoNew = _interopRequireDefault(require("./Logos/components/TswLogoNew"));
var _ApplePayMark = _interopRequireDefault(require("./Logos/components/ApplePayMark"));
var _GooglePayMark = _interopRequireDefault(require("./Logos/components/GooglePayMark"));
var _ThinAnchor = _interopRequireDefault(require("./Icons/components/ThinAnchor"));
var _VolumeMute = _interopRequireDefault(require("./Icons/components/VolumeMute"));
var _Volume = _interopRequireDefault(require("./Icons/components/Volume"));
var _Images = _interopRequireDefault(require("./Icons/components/Images"));
var _FingerClick = _interopRequireDefault(require("./Icons/components/FingerClick"));
var _MaleFemale = _interopRequireDefault(require("./Icons/components/MaleFemale"));
var _SuitcaseWorld = _interopRequireDefault(require("./Icons/components/SuitcaseWorld"));
var _Fireworks = _interopRequireDefault(require("./Icons/components/Fireworks"));
var _Module = _interopRequireDefault(require("./Icons/components/Module"));
var _Crossroad = _interopRequireDefault(require("./Icons/components/Crossroad"));
var _FullArrowRight = _interopRequireDefault(require("./Icons/components/FullArrowRight"));
var _Cocktail = _interopRequireDefault(require("./Icons/components/Cocktail"));
var _DrinkGlass = _interopRequireDefault(require("./Icons/components/DrinkGlass"));
var _Taco = _interopRequireDefault(require("./Icons/components/Taco"));
var _Refund = _interopRequireDefault(require("./Icons/components/Refund"));
var _WaterTaxi = _interopRequireDefault(require("./Icons/components/WaterTaxi"));
var _Baggage = _interopRequireDefault(require("./Icons/components/Baggage"));
var _Port = _interopRequireDefault(require("./Icons/components/Port"));
var _PowerWater = _interopRequireDefault(require("./Icons/components/PowerWater"));
var _WaterBottle = _interopRequireDefault(require("./Icons/components/WaterBottle"));
var _Cereal = _interopRequireDefault(require("./Icons/components/Cereal"));
var _OvenMit = _interopRequireDefault(require("./Icons/components/OvenMit"));
var _Cameras = _interopRequireDefault(require("./Icons/components/Cameras"));
var _Camera = _interopRequireDefault(require("./Icons/components/Camera"));
var _Skipper = _interopRequireDefault(require("./Icons/components/Skipper"));
var _Checkmark = _interopRequireDefault(require("./Icons/components/Checkmark"));
var _Vacuum = _interopRequireDefault(require("./Icons/components/Vacuum"));
var _Towel = _interopRequireDefault(require("./Icons/components/Towel"));
var _Dingy = _interopRequireDefault(require("./Icons/components/Dingy"));
var _Stereo = _interopRequireDefault(require("./Icons/components/Stereo"));
var _Vip = _interopRequireDefault(require("./Icons/components/Vip"));
var _Dj = _interopRequireDefault(require("./Icons/components/Dj"));
var _Cross = _interopRequireDefault(require("./Icons/components/Cross"));
var _Plus = _interopRequireDefault(require("./Icons/components/Plus"));
var _Filter = _interopRequireDefault(require("./Icons/components/Filter"));
var _Play = _interopRequireDefault(require("./Icons/components/Play"));
var _PlayOutline = _interopRequireDefault(require("./Icons/components/PlayOutline"));
var _ArrowRight = _interopRequireDefault(require("./Icons/components/ArrowRight"));
var _ArrowLeft = _interopRequireDefault(require("./Icons/components/ArrowLeft"));
var _ArrowUp = _interopRequireDefault(require("./Icons/components/ArrowUp"));
var _ArrowDown = _interopRequireDefault(require("./Icons/components/ArrowDown"));
var _Quote = _interopRequireDefault(require("./Icons/components/Quote"));
var _User = _interopRequireDefault(require("./Icons/components/User"));
var _Phone = _interopRequireDefault(require("./Icons/components/Phone"));
var _Email = _interopRequireDefault(require("./Icons/components/Email"));
var _Calendar = _interopRequireDefault(require("./Icons/components/Calendar"));
var _Hamburger = _interopRequireDefault(require("./Icons/components/Hamburger"));
var _Star = _interopRequireDefault(require("./Icons/components/Star"));
var _StarFill = _interopRequireDefault(require("./Icons/components/StarFill"));
var _CheckCircle = _interopRequireDefault(require("./Icons/components/CheckCircle"));
var _CheckCircleFill = _interopRequireDefault(require("./Icons/components/CheckCircleFill"));
var _CrossCircleFill = _interopRequireDefault(require("./Icons/components/CrossCircleFill"));
var _InfoIFill = _interopRequireDefault(require("./Icons/components/InfoIFill"));
var _AlertFill = _interopRequireDefault(require("./Icons/components/AlertFill"));
var _SeaTransportYachtBold = _interopRequireDefault(require("./Icons/components/SeaTransportYachtBold"));
var _SeaTransportYacht = _interopRequireDefault(require("./Icons/components/SeaTransportYacht"));
var _SeaTransportBoat = _interopRequireDefault(require("./Icons/components/SeaTransportBoat"));
var _Plane = _interopRequireDefault(require("./Icons/components/Plane"));
var _Music = _interopRequireDefault(require("./Icons/components/Music"));
var _MusicDance = _interopRequireDefault(require("./Icons/components/MusicDance"));
var _SeaTransportWheel = _interopRequireDefault(require("./Icons/components/SeaTransportWheel"));
var _Attachment = _interopRequireDefault(require("./Icons/components/Attachment"));
var _Headphones = _interopRequireDefault(require("./Icons/components/Headphones"));
var _Speedometer = _interopRequireDefault(require("./Icons/components/Speedometer"));
var _Info = _interopRequireDefault(require("./Icons/components/Info"));
var _CalendarDate = _interopRequireDefault(require("./Icons/components/CalendarDate"));
var _Map = _interopRequireDefault(require("./Icons/components/Map"));
var _Users = _interopRequireDefault(require("./Icons/components/Users"));
var _Ticket = _interopRequireDefault(require("./Icons/components/Ticket"));
var _Location = _interopRequireDefault(require("./Icons/components/Location"));
var _LocationBold = _interopRequireDefault(require("./Icons/components/LocationBold"));
var _Snow = _interopRequireDefault(require("./Icons/components/Snow"));
var _Shower = _interopRequireDefault(require("./Icons/components/Shower"));
var _Ruler = _interopRequireDefault(require("./Icons/components/Ruler"));
var _Shower2 = _interopRequireDefault(require("./Icons/components/Shower2"));
var _Bed = _interopRequireDefault(require("./Icons/components/Bed"));
var _BedOutline = _interopRequireDefault(require("./Icons/components/BedOutline"));
var _Logout = _interopRequireDefault(require("./Icons/components/Logout"));
var _Travel = _interopRequireDefault(require("./Icons/components/Travel"));
var _Lock = _interopRequireDefault(require("./Icons/components/Lock"));
var _Sort = _interopRequireDefault(require("./Icons/components/Sort"));
var _Id = _interopRequireDefault(require("./Icons/components/Id"));
var _UserStar = _interopRequireDefault(require("./Icons/components/UserStar"));
var _Trash = _interopRequireDefault(require("./Icons/components/Trash"));
var _Legal = _interopRequireDefault(require("./Icons/components/Legal"));
var _Booking = _interopRequireDefault(require("./Icons/components/Booking"));
var _ThumbUp = _interopRequireDefault(require("./Icons/components/ThumbUp"));
var _ThumbDown = _interopRequireDefault(require("./Icons/components/ThumbDown"));
var _RatingStarBadge = _interopRequireDefault(require("./Icons/components/RatingStarBadge"));
var _RatingStarCircle = _interopRequireDefault(require("./Icons/components/RatingStarCircle"));
var _Flame = _interopRequireDefault(require("./Icons/components/Flame"));
var _Ban = _interopRequireDefault(require("./Icons/components/Ban"));
var _Minus = _interopRequireDefault(require("./Icons/components/Minus"));
var _Flash = _interopRequireDefault(require("./Icons/components/Flash"));
var _Ac = _interopRequireDefault(require("./Icons/components/Ac"));
var _Time = _interopRequireDefault(require("./Icons/components/Time"));
var _TimeOutline = _interopRequireDefault(require("./Icons/components/TimeOutline"));
var _Edit = _interopRequireDefault(require("./Icons/components/Edit"));
var _Person = _interopRequireDefault(require("./Icons/components/Person"));
var _Group = _interopRequireDefault(require("./Icons/components/Group"));
var _Guy = _interopRequireDefault(require("./Icons/components/Guy"));
var _Girl = _interopRequireDefault(require("./Icons/components/Girl"));
var _Dollar = _interopRequireDefault(require("./Icons/components/Dollar"));
var _ShieldCheck = _interopRequireDefault(require("./Icons/components/ShieldCheck"));
var _Travel2 = _interopRequireDefault(require("./Icons/components/Travel2"));
var _HeartOutline = _interopRequireDefault(require("./Icons/components/HeartOutline"));
var _ArrowThickCircleDown = _interopRequireDefault(require("./Icons/components/ArrowThickCircleDown"));
var _Link = _interopRequireDefault(require("./Icons/components/Link"));
var _FoodAndDrink = _interopRequireDefault(require("./Icons/components/FoodAndDrink"));
var _TravelInsurance = _interopRequireDefault(require("./Icons/components/TravelInsurance"));
var _OurMountains = _interopRequireDefault(require("./Icons/components/OurMountains"));
var _Hotel = _interopRequireDefault(require("./Icons/components/Hotel"));
var _Speakers = _interopRequireDefault(require("./Icons/components/Speakers"));
var _Champagne = _interopRequireDefault(require("./Icons/components/Champagne"));
var _Skiing = _interopRequireDefault(require("./Icons/components/Skiing"));
var _Beer = _interopRequireDefault(require("./Icons/components/Beer"));
var _BusinessClimb = _interopRequireDefault(require("./Icons/components/BusinessClimb"));
var _Reception = _interopRequireDefault(require("./Icons/components/Reception"));
var _Sauna = _interopRequireDefault(require("./Icons/components/Sauna"));
var _Search = _interopRequireDefault(require("./Icons/components/Search"));
var _LockCircle = _interopRequireDefault(require("./Icons/components/LockCircle"));
var _Call = _interopRequireDefault(require("./Icons/components/Call"));
var _ReceptionBell = _interopRequireDefault(require("./Icons/components/ReceptionBell"));
var _JapanOverview = _interopRequireDefault(require("./Icons/components/JapanOverview1"));
var _JapanOverview2 = _interopRequireDefault(require("./Icons/components/JapanOverview2"));
var _JapanOverview3 = _interopRequireDefault(require("./Icons/components/JapanOverview3"));
var _Snowboarder = _interopRequireDefault(require("./Icons/components/Snowboarder"));
var _Apartment = _interopRequireDefault(require("./Icons/components/Apartment"));
var _Bedroom = _interopRequireDefault(require("./Icons/components/Bedroom"));
var _Guests = _interopRequireDefault(require("./Icons/components/Guests"));
var _TakingPictures = _interopRequireDefault(require("./Icons/components/TakingPictures"));
var _SofaOutline = _interopRequireDefault(require("./Icons/components/SofaOutline"));
var _Sofa = _interopRequireDefault(require("./Icons/components/Sofa"));
var _Pictures = _interopRequireDefault(require("./Icons/components/Pictures"));
var _AccountingCoins = _interopRequireDefault(require("./Icons/components/AccountingCoins"));
var _ChecklistPen = _interopRequireDefault(require("./Icons/components/ChecklistPen"));
var _FireworksPeopleWatch = _interopRequireDefault(require("./Icons/components/FireworksPeopleWatch"));
var _CreditCardSync = _interopRequireDefault(require("./Icons/components/CreditCardSync"));
var _Canoe = _interopRequireDefault(require("./Icons/components/Canoe"));
var _UserLite = _interopRequireDefault(require("./Icons/components/UserLite"));
var _BunkBed = _interopRequireDefault(require("./Icons/components/BunkBed"));
var _PeopleManCap = _interopRequireDefault(require("./Icons/components/PeopleManCap"));
var _KeyboardArrowRight = _interopRequireDefault(require("./Icons/components/KeyboardArrowRight"));
var _KeyboardArrowDown = _interopRequireDefault(require("./Icons/components/KeyboardArrowDown"));
var _DuckWater = _interopRequireDefault(require("./Icons/components/DuckWater"));
var _BigArrowDown = _interopRequireDefault(require("./Icons/components/BigArrowDown"));
var _Globe = _interopRequireDefault(require("./Icons/components/Globe"));
var _RotatePhone = _interopRequireDefault(require("./Icons/components/RotatePhone"));
var _Puck = _interopRequireDefault(require("./Icons/components/Puck"));
var _PuckStrikeThrough = _interopRequireDefault(require("./Icons/components/PuckStrikeThrough"));
var _Bookmark = _interopRequireDefault(require("./Icons/components/Bookmark"));
var _BookmarkOutline = _interopRequireDefault(require("./Icons/components/BookmarkOutline"));
var _Host = _interopRequireDefault(require("./Icons/components/Host"));
var _Halfboard = _interopRequireDefault(require("./Icons/components/Halfboard"));
var _YachtTypeMonohull = _interopRequireDefault(require("./Icons/components/YachtTypeMonohull"));
var _YachtTypeCatamaran = _interopRequireDefault(require("./Icons/components/YachtTypeCatamaran"));
var _YachtTypeCustom = _interopRequireDefault(require("./Icons/components/YachtTypeCustom"));
var _Trust = _interopRequireDefault(require("./Icons/components/Trust"));
var templates = {
  // Trustpilot
  5: _Trustpilot["default"],
  '5-small': _Trustpilot5Small["default"],
  '4-5': _Trustpilot2["default"],
  '4-5-small': _Trustpilot45Small["default"],
  // Social
  'twitter-brand': _TwitterBrand["default"],
  linkedin: _Linkedin["default"],
  'linkedin-brand': _LinkedinBrand["default"],
  'youtube-brand': _YoutubeBrand["default"],
  instagram: _Instagram["default"],
  'facebook-brand': _FacebookBrand["default"],
  'facebook-brand-2': _FacebookBrand2["default"],
  facebook: _Facebook["default"],
  gravatar: _Gravatar["default"],
  snapchat: _Snapchat["default"],
  twitter: _Twitter["default"],
  tiktok: _Tiktok["default"],
  youtube: _Youtube["default"],
  // Logos
  maaji: _Maaji["default"],
  'air-tahiti': _AirTahiti["default"],
  'tyw-logo': _TywLogo["default"],
  'tyw-mini-logo': _TywMiniLogo["default"],
  'tsw-logo': _TswLogo["default"],
  'eurotrips-logo': _EurotripsLogo["default"],
  'abta-logo': _AbtaLogo["default"],
  'cn-logo': _CnLogo["default"],
  'day8-logo-fill': _Day8LogoFill["default"],
  'day8-logo': _Day8Logo["default"],
  'ohso-logo': _OhsoLogo["default"],
  'ynf-logo': _YnfLogo["default"],
  'qd-logo': _QdLogo["default"],
  ultra: _Ultra["default"],
  'ynf-logo-fill': _YnfLogoFill["default"],
  'ynf-mini-logo': _YnfMiniLogo["default"],
  'ynf-logo-black-outline': _YnfLogoBlackOutline["default"],
  visa: _Visa["default"],
  mastercard: _Mastercard["default"],
  amex: _Amex["default"],
  'aegean-logo': _AegeanLogo["default"],
  'vacay-logo': _VacayLogo["default"],
  'tsw-logo-new': _TswLogoNew["default"],
  'apple-pay-mark': _ApplePayMark["default"],
  'google-pay-mark': _GooglePayMark["default"],
  // Icons
  'thin-anchor': _ThinAnchor["default"],
  'volume-mute': _VolumeMute["default"],
  volume: _Volume["default"],
  images: _Images["default"],
  'finger-click': _FingerClick["default"],
  'male-female': _MaleFemale["default"],
  'suitcase-world': _SuitcaseWorld["default"],
  fireworks: _Fireworks["default"],
  module: _Module["default"],
  crossroad: _Crossroad["default"],
  'full-arrow-right': _FullArrowRight["default"],
  cocktail: _Cocktail["default"],
  'drink-glass': _DrinkGlass["default"],
  taco: _Taco["default"],
  refund: _Refund["default"],
  'water-taxi': _WaterTaxi["default"],
  baggage: _Baggage["default"],
  port: _Port["default"],
  'power-water': _PowerWater["default"],
  'water-bottle': _WaterBottle["default"],
  cereal: _Cereal["default"],
  'oven-mit': _OvenMit["default"],
  cameras: _Cameras["default"],
  camera: _Camera["default"],
  skipper: _Skipper["default"],
  checkmark: _Checkmark["default"],
  vacuum: _Vacuum["default"],
  towel: _Towel["default"],
  dingy: _Dingy["default"],
  stereo: _Stereo["default"],
  vip: _Vip["default"],
  dj: _Dj["default"],
  cross: _Cross["default"],
  plus: _Plus["default"],
  filter: _Filter["default"],
  play: _Play["default"],
  'play-outline': _PlayOutline["default"],
  'arrow-right': _ArrowRight["default"],
  'arrow-left': _ArrowLeft["default"],
  'arrow-up': _ArrowUp["default"],
  'arrow-down': _ArrowDown["default"],
  quote: _Quote["default"],
  user: _User["default"],
  phone: _Phone["default"],
  email: _Email["default"],
  calendar: _Calendar["default"],
  hamburger: _Hamburger["default"],
  star: _Star["default"],
  'star-fill': _StarFill["default"],
  'check-circle': _CheckCircle["default"],
  'check-circle-fill': _CheckCircleFill["default"],
  'cross-circle-fill': _CrossCircleFill["default"],
  'info-i-fill': _InfoIFill["default"],
  'alert-fill': _AlertFill["default"],
  'sea-transport-yacht-bold': _SeaTransportYachtBold["default"],
  'sea-transport-yacht': _SeaTransportYacht["default"],
  'sea-transport-boat': _SeaTransportBoat["default"],
  plane: _Plane["default"],
  music: _Music["default"],
  'music-dance': _MusicDance["default"],
  'sea-transport-wheel': _SeaTransportWheel["default"],
  attachment: _Attachment["default"],
  headphones: _Headphones["default"],
  speedometer: _Speedometer["default"],
  info: _Info["default"],
  'calendar-date': _CalendarDate["default"],
  map: _Map["default"],
  users: _Users["default"],
  ticket: _Ticket["default"],
  location: _Location["default"],
  'location-bold': _LocationBold["default"],
  snow: _Snow["default"],
  shower: _Shower["default"],
  ruler: _Ruler["default"],
  shower2: _Shower2["default"],
  bed: _Bed["default"],
  'bed-outline': _BedOutline["default"],
  logout: _Logout["default"],
  travel: _Travel["default"],
  lock: _Lock["default"],
  id: _Id["default"],
  'user-star': _UserStar["default"],
  sort: _Sort["default"],
  trash: _Trash["default"],
  legal: _Legal["default"],
  booking: _Booking["default"],
  'thumb-up': _ThumbUp["default"],
  'thumb-down': _ThumbDown["default"],
  'rating-star-badge': _RatingStarBadge["default"],
  'rating-star-circle': _RatingStarCircle["default"],
  flame: _Flame["default"],
  ban: _Ban["default"],
  minus: _Minus["default"],
  flash: _Flash["default"],
  ac: _Ac["default"],
  time: _Time["default"],
  'time-outline': _TimeOutline["default"],
  edit: _Edit["default"],
  person: _Person["default"],
  group: _Group["default"],
  guy: _Guy["default"],
  girl: _Girl["default"],
  dollar: _Dollar["default"],
  'shield-check': _ShieldCheck["default"],
  travel2: _Travel2["default"],
  'heart-outline': _HeartOutline["default"],
  'arrow-thick-circle-down': _ArrowThickCircleDown["default"],
  link: _Link["default"],
  'food-and-drink': _FoodAndDrink["default"],
  'travel-insurance': _TravelInsurance["default"],
  'our-mountians': _OurMountains["default"],
  hotel: _Hotel["default"],
  speakers: _Speakers["default"],
  champagne: _Champagne["default"],
  skiing: _Skiing["default"],
  beer: _Beer["default"],
  businessClimb: _BusinessClimb["default"],
  reception: _Reception["default"],
  sauna: _Sauna["default"],
  search: _Search["default"],
  'lock-circle': _LockCircle["default"],
  call: _Call["default"],
  'reception-bell': _ReceptionBell["default"],
  'japan-overview-1': _JapanOverview["default"],
  'japan-overview-2': _JapanOverview2["default"],
  'japan-overview-3': _JapanOverview3["default"],
  snowboarder: _Snowboarder["default"],
  apartment: _Apartment["default"],
  bedroom: _Bedroom["default"],
  guests: _Guests["default"],
  'taking-pictures': _TakingPictures["default"],
  'sofa-outline': _SofaOutline["default"],
  sofa: _Sofa["default"],
  pictures: _Pictures["default"],
  'accounting-coins': _AccountingCoins["default"],
  'checklist-pen': _ChecklistPen["default"],
  'fireworks-people-watch': _FireworksPeopleWatch["default"],
  'credit-card-sync': _CreditCardSync["default"],
  canoe: _Canoe["default"],
  'user-lite': _UserLite["default"],
  'bunk-bed': _BunkBed["default"],
  'people-man-cap': _PeopleManCap["default"],
  'keyboard-arrow-right': _KeyboardArrowRight["default"],
  'keyboard-arrow-down': _KeyboardArrowDown["default"],
  'duck-water': _DuckWater["default"],
  'big-arrow-down': _BigArrowDown["default"],
  globe: _Globe["default"],
  rotatePhone: _RotatePhone["default"],
  puck: _Puck["default"],
  puckStrikeThrough: _PuckStrikeThrough["default"],
  bookmark: _Bookmark["default"],
  'bookmark-outline': _BookmarkOutline["default"],
  host: _Host["default"],
  halfboard: _Halfboard["default"],
  yacht_type_monohull: _YachtTypeMonohull["default"],
  yacht_type_catamaran: _YachtTypeCatamaran["default"],
  yacht_type_custom: _YachtTypeCustom["default"],
  trust: _Trust["default"],
  whatsapp: _Whatsapp["default"]
};
var Svg = function Svg(props) {
  if (!Object.prototype.hasOwnProperty.call(templates, props.name)) return null;
  var TemplateToRender = templates[props.name];
  return /*#__PURE__*/_react["default"].createElement(TemplateToRender, props);
};
Svg.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Svg.defaultProps = {
  fill: '#ffffff',
  className: '',
  title: ''
};
var _default = exports["default"] = Svg;